// ikrush-flash-countdown.js: ticks [data-flash-countdown] down to the next 00:00 Europe/London.
(function () {
  var TZ = 'Europe/London';
  var fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric'
  });

  // London wall clock for an instant, read back as if it were UTC.
  function wall(ms) {
    var p = {};
    fmt.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
  }

  // Epoch ms of the next 00:00 London time (handles GMT and BST, including changeover days).
  function nextMidnight(now) {
    var w = new Date(wall(now));
    var guess = Date.UTC(w.getUTCFullYear(), w.getUTCMonth(), w.getUTCDate() + 1, 0, 0, 0);
    var target = guess - (wall(guess) - guess);
    target = guess - (wall(target) - target);
    return target;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var els = document.querySelectorAll('[data-flash-countdown]');
    if (!els.length) return;
    var now = Date.now();
    var left = Math.max(0, Math.floor((nextMidnight(now) - now) / 1000));
    var text = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (left > 0) {
        if (el.textContent !== text) el.textContent = text;
      } else {
        el.textContent = 'Ended';
        var wrap = el.closest('[data-flash-deal]');
        if (wrap) wrap.hidden = true;
      }
    }
  }

  tick();
  setInterval(tick, 1000); // re-queries each tick so rerendered product blocks are picked up
})();
